import { getFilename, getUrlForWidth } from '../utils/widen-utils';

const WEB_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.tif', '.tiff'];
const WEB_IMAGE_FORMATS = ['JPEG', 'PNG', 'WEBP', 'GIF', 'TIFF'];

const decodeHtmlEntities = (value) => {
  if (typeof value !== 'string' || !value.includes('&')) {
    return value || '';
  }
  const decoder = document.createElement('textarea');
  decoder.innerHTML = value;
  return decoder.value;
};

const flattenMetaDataArray = (arr) => {
  if (!arr || !Array.isArray(arr)) {
    return '';
  }
  return arr.map(decodeHtmlEntities).join(',');
};

const getFirstMetaDataArrayValue = (arr) => {
  if (!arr || !Array.isArray(arr) || arr.length === 0) {
    return '';
  }
  return decodeHtmlEntities(arr[0]);
};

const isWebReadyImage = (item) => {
  if (!item?.file_properties || item.file_properties.format_type !== 'image') {
    return false;
  }

  const format = (item.file_properties.format || '').toUpperCase();
  if (WEB_IMAGE_FORMATS.includes(format)) {
    return true;
  }

  const filename = (item.filename || '').toLowerCase();
  return WEB_IMAGE_EXTENSIONS.some((ext) => filename.endsWith(ext));
};

const getAssetDescription = (fields) => {
  const caption =
    getFirstMetaDataArrayValue(fields.webReadyCaption) ||
    getFirstMetaDataArrayValue(fields.Caption) ||
    getFirstMetaDataArrayValue(fields.description);

  if (caption) {
    return caption;
  }

  return 'A room scene featuring Signature Series products.';
};

/**
 * Maps a Widen search response into gallery items.
 * @returns {number} Count of raw items in this response (for pagination offset).
 */
const parseWidenAssets = (data) => {
  if (!window.MediaGalleryData) {
    window.MediaGalleryData = { mediaItems: [], filters: {} };
  }
  if (!Array.isArray(window.MediaGalleryData.mediaItems)) {
    window.MediaGalleryData.mediaItems = [];
  }

  const items = data?.items || [];
  items.forEach((item) => {
    if (!isWebReadyImage(item)) {
      return;
    }

    const fields = item.metadata?.fields || {};
    const product = flattenMetaDataArray(fields.Product);

    window.MediaGalleryData.mediaItems.push({
      id: item.external_id,
      filename: getFilename(item.filename),
      imageUrl: getUrlForWidth(item.filename, item.external_id, 1024),
      thumbUrl: getUrlForWidth(item.filename, item.external_id, 360),
      description: getAssetDescription(fields),
      product,
      color: flattenMetaDataArray(fields.colorRange),
      roomType: flattenMetaDataArray(fields.RoomType),
      solution: flattenMetaDataArray(fields.solutions || fields.Solutions || fields.Solution),
      type: 'Image',
    });
  });

  return items.length;
};

export {
  parseWidenAssets,
  isWebReadyImage,
  decodeHtmlEntities,
  flattenMetaDataArray,
  getFirstMetaDataArrayValue,
};
